export const userRemovedExtension = (param: string = '') => {
  if (
    param.split('=')[0] === 'fromExtension' &&
    param.split('=')[1] === 'false'
  ) {
    window.localStorage.removeItem('extensionDownloaded')
  }
  return
}
